import React from 'react';
import { Section } from './ui/Section';
export function AcceleratorComparison() {
  const rows = [{
    situation: 'Quieres instalar el dashboard pero no sabes empezar',
    without: 'Pierdes días sin aplicar nada',
    with: 'Dashboard de Notion y Excel ya configurado: solo metes tus datos'
  }, {
    situation: 'Necesitas enviar una propuesta pero no tienes formato',
    without: 'Mandas un email de texto plano que no cierra',
    with: '6 Plantillas de Canva listas: propuesta, presupuesto, factura y bienvenida'
  }, {
    situation: 'Un cliente no paga y no sabes qué escribir',
    without: 'Improvisas y quedas mal',
    with: '15 textos de copiar y pegar para cada situación crítica'
  }, {
    situation: 'Arrancas un proyecto nuevo y no sabes cómo organizarlo',
    without: 'Cada cliente es un caos diferente',
    with: 'Protocolo de Onboarding de 5 días que profesionaliza todo desde el día 1'
  }, {
    situation: 'Terminas el mes sin saber cuánto ganaste realmente',
    without: 'Hacienda te pilla por sorpresa',
    with: 'Control financiero automatizado con alertas de facturas vencidas'
  }];
  const includes = ['Dashboard Maestro de Notion y Excel: Tu centro de mando completo con clientes, proyectos, facturas e ingresos. Solo duplicas y empiezas.', '6 Plantillas de Canva Pro: Propuesta de alto valor, presupuesto flash, PDF de bienvenida, factura profesional, portfolio y presentación de servicios.', '15 Textos de Copiar y Pegar: Scripts exactos para gestión de precios, cobros, cambios de alcance, clientes potenciales y cierre de proyectos.', 'Protocolo de Onboarding en 5 Días: Cómo arrancar cada proyecto de forma que el cliente te respete desde el minuto uno.', 'Checklists de Procesos: Arranque, entrega, cierre de proyecto, cierre de mes y revisión trimestral. Para que nunca se te olvide nada importante.', 'Plan de Instalación en 24 Horas: El sistema completo funcionando antes de que acabe mañana.'];
  return <Section data-id="element-22">
      <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-23">
        🕊️ ¿QUÉ AGREGA EL TOOLKIT ACELERADOR PRO?
      </h2>

      <div className="overflow-x-auto mb-16 pb-4" data-id="element-24">
        <table className="w-full min-w-[800px] border-collapse" data-id="element-25">
          <thead data-id="element-26">
            <tr data-id="element-27">
              <th className="text-left p-4 border-b border-neutral-800 text-neutral-400 font-medium w-1/3" data-id="element-28">
                Situación real
              </th>
              <th className="text-left p-4 border-b border-neutral-800 text-red-400 font-medium w-1/3" data-id="element-29">
                ❌ Sin el Toolkit
              </th>
              <th className="text-left p-4 border-b border-neutral-800 text-green-400 font-medium w-1/3" data-id="element-30">
                ✅ Con el Toolkit
              </th>
            </tr>
          </thead>
          <tbody data-id="element-31">
            {rows.map((row, i) => <tr key={i} className="hover:bg-brand-card/50 transition-colors" data-id="element-32">
                <td className="p-4 border-b border-neutral-800/50 text-neutral-300" data-id="element-33">
                  {row.situation}
                </td>
                <td className="p-4 border-b border-neutral-800/50 text-neutral-500" data-id="element-34">
                  {row.without}
                </td>
                <td className="p-4 border-b border-neutral-800/50 text-white font-medium" data-id="element-35">
                  {row.with}
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>

      <div className="bg-brand-card border border-brand-accent/30 rounded-2xl p-8 max-w-3xl mx-auto" data-id="element-36">
        <h3 className="text-xl font-bold text-brand-accent mb-6" data-id="element-37">
          ✅ EL TOOLKIT ACELERADOR INCLUYE:
        </h3>
        <div className="grid md:grid-cols-2 gap-4" data-id="element-38">
          {includes.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-39">
              <span className="text-brand-accent mt-1 shrink-0" data-id="element-40">⚡</span>
              <span className="text-neutral-200" data-id="element-41">{item}</span>
            </div>)}
        </div>
      </div>
    </Section>;
}